const CHARACTERS = [{
  id: 'yeti',
  name: 'Yeti',
  img: {
    src: require('assets/images/character-yeti-idle.png').default,
    alt: '',
  },
  imgHappy: {
    src: require('assets/images/character-yeti-happy.png').default,
    alt: '',
  },
  imgSad: {
    src: require('assets/images/character-yeti-sad.png').default,
    alt: '',
  },
  titleImg: {
    en: {
      src: require('assets/images/en/character/text-yeti.svg').default,
      alt: 'Yeti',
    },
    es: {
      src: require('assets/images/es/character/text-yeti.svg').default,
      alt: 'Yeti',
    }
  },
},{
  id: 'seal',
  name: 'Seal',
  img: {
    src: require('assets/images/character-seal-idle.png').default,
    alt: '',
  },
  imgHappy: {
    src: require('assets/images/character-seal-happy.png').default,
    alt: '',
  },
  imgSad: {
    src: require('assets/images/character-seal-sad.png').default,
    alt: '',
  },
  titleImg: {
    en: {
      src: require('assets/images/en/character/text-seal.svg').default,
      alt: 'Seal',
    },
    es: {
      src: require('assets/images/es/character/text-seal.svg').default,
      alt: 'Foca',
    }
  },
},{
  id: 'bear',
  name: 'Bear',
  img: {
    src: require('assets/images/character-bear-idle.png').default,
    alt: '',
  },
  imgHappy: {
    src: require('assets/images/character-bear-happy.png').default,
    alt: '',
  },
  imgSad: {
    src: require('assets/images/character-bear-sad.png').default,
    alt: '',
  },
  titleImg: {
    en: {
      src: require('assets/images/en/character/text-bear.svg').default,
      alt: 'Bear',
    },
    es: {
      src: require('assets/images/es/character/text-bear.svg').default,
      alt: 'Oso',
    },
  },
}]

export const getCharacter = (character) => {
  return CHARACTERS.find(c => c.id === character)
}

export const getAllCharacters = () => CHARACTERS

const Characters = {
  getCharacter,
  getAllCharacters,
}

export default Characters
